import React from 'react';
import { createPortal } from 'react-dom';
import { addClassNames } from '../Functions/Helper/Component';
import BootstrapModal from "bootstrap/js/dist/modal";

const context = React.createContext({});
const uuid = "mcb-pitch-modal";
export function ModalPortalProvider({children}) {
    const modalDOM = React.useMemo(() => document.getElementById(uuid), []);
    const modalDialogDOM = React.useMemo(() => document.getElementById(uuid + "-dialog"), []);
    const modalContentDOM = React.useMemo(() => document.getElementById(uuid + "-content"), []);

    const ModalPortal = React.useCallback(({ 
        children,
        modalType = "modal-lg",
        modalDialogClassName,
        modalContentClassName,
        ...props
    }) => {
        modalDOM.className = `modal ${modalType} fade${modalDOM.classList.contains("show")? " show": ""}`;
        modalDialogDOM.className = addClassNames("modal-dialog", modalDialogClassName);
        modalContentDOM.className = addClassNames("modal-content", modalContentClassName);
        
        Object.entries(props).forEach(([key, value]) => {
            modalDOM.setAttribute(key, value);
        });
        return createPortal(children, modalContentDOM);
    }, [modalContentDOM, modalDialogDOM, modalDOM]);

    const modal = React.useMemo(() => new BootstrapModal(document.getElementById(uuid)), []);
    
    return (
        <context.Provider value={{uuid, modal, modalDOM, modalDialogDOM, modalContentDOM,  ModalPortal}}>
            {children}
        </context.Provider>
    
    );
}

export default function useModalPortal() {
    return React.useContext(context);
}